import Cookies from 'universal-cookie';
import { v4 as uuid } from 'uuid';

const DEVICE_ID = 'device_id';

const cookies = new Cookies();

let deviceId: string = cookies.get(DEVICE_ID);

export const ensureDeviceId = (domain: string | undefined) => {
  if (!deviceId) {
    deviceId = uuid();

    cookies.set(DEVICE_ID, deviceId, {
      path: '/',
      maxAge: 60 * 60 * 24 * 365,
      domain,
      sameSite: 'lax',
    });
  }

  return deviceId;
};
